// TileTitle.js
import React from 'react';
import { Typography } from '@mui/material';

const TileTitle = ({ children, sx = {}, ...props }) => (
  <Typography
    variant="h6"
    sx={{
      height:20,
      color: '#393939',
      whiteSpace:'nowrap',
    //   fontFeatureSettings: "'liga' off, 'clig' off",
    //   fontFamily: '"Pretendard Variable"',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 'normal',
      alignSelf: 'flex-start',
      marginBottom: 2,
      ...sx, // 추가 스타일 적용 가능
    }}
    {...props}
  >
    {children}
  </Typography>
);

export default TileTitle;